import React, { useState } from "react";
import { Table, Input, Button, Space, Tag } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ENDPOINTS } from "../../Services/ENDPOINTS";

const TableS = ({ data, handleEdit, handleDelete }) => {
  const [searchText, setSearchText] = useState("");

  const filteredData = data?.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: "SI No",
      render: (_, __, index) => index + 1,
      align: 'center'
    },
    {
      title: "Image",
      dataIndex: "upload_img",
      key: "upload_img",
      render: (img) => (
        img ? (
          <img
            src={`${ENDPOINTS.cleanBase}${img}`}
            alt="car"
            style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 6 }}
          />
        ) : (
          "No Image"
        )
      ),
    },
    { title: "Name", dataIndex: "name" },
    { title: "Description", dataIndex: "description" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        status ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>
      ),
    },
    // { title: "Added By", dataIndex: "added_by", render: (v) => v ?? "-" },
    { title: "Added On", dataIndex: "added_on" },
    { title: "Updated On", dataIndex: "updated_on" },

    // ACTIONS COLUMN
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record.id)}
          />
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Input
        placeholder="Search..."
        style={{ width: 400, marginBottom: 15 }}
        value={searchText}
        allowClear
        onChange={(e) => setSearchText(e.target.value)}
      />

      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="id"
      />
    </div>
  );
};

export default TableS;  
